module.exports = __webpack_public_path__ + "img/icon-lightbulb-gray.8512598f.svg";